import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { requisitarAtivacao } from './useAtivacaoLinhas';
import { ETAPAS_QUALIDADE_INBOX, type ConversaFilaQualidade } from '@/lib/qualidadeInbox';

// O dicionário é documento → etapas. Quem decide quais conversas aparecem é a
// RLS do gateway, na consulta da própria lista — não esta rota.
export const soDigitos = (v: string | null | undefined) => (v || '').replace(/\D/g, '');

export function filaQualidadeOptions(usuario: string | undefined, proprias = false) {
  return {
    queryKey: ['qualidade-inbox', 'fila', usuario, proprias],
    enabled: !!usuario,
    staleTime: 30_000,
    refetchInterval: 60_000,
    queryFn: () => requisitarAtivacao<ConversaFilaQualidade[]>(`fila-inbox?proprias=${proprias}`),
  };
}

export type { ConversaFilaQualidade, MomentoQualidade } from '@/lib/qualidadeInbox';
export { competenciasDaEtapa, documentosDaEtapa, estadosDaEtapa } from '@/lib/qualidadeInbox';

export function useFilaQualidadeInbox(proprias = false) {
  const { profile } = useAuth();
  const client = useQueryClient();
  const query = useQuery(filaQualidadeOptions(profile?.id, proprias));
  useEffect(() => {
    if (query.dataUpdatedAt) void client.invalidateQueries({ predicate: q =>
      q.queryKey[0] === 'whatsapp-conversations' && String(q.queryKey[1]).startsWith('qualidade:') });
  }, [client, query.dataUpdatedAt]);
  return query;
}

/** Devolve documento (só dígitos) → rótulo das etapas, para o chip da lista. */
export function useQualidadeInbox(documentos: string[]) {
  const { profile } = useAuth();
  return useQuery({ ...filaQualidadeOptions(profile?.id), enabled: !!profile?.id && documentos.length > 0,
    select: (rows) => {
      const resultado: Record<string, string> = {};
      for (const row of rows) resultado[row.documento] = row.etapas.map(e => ETAPAS_QUALIDADE_INBOX[e as keyof typeof ETAPAS_QUALIDADE_INBOX]).filter(Boolean).join(' · ');
      return resultado;
    },
  });
}
